var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.07 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.27,72.72A246.64,246.64,0,0,0,263.7,0h0C126.56,0,15.39,111.21,15.41,248.35A248.28,248.28,0,0,0,43,362.16L1.3,481.39a23,23,0,0,0,14.1,29.32A23.27,23.27,0,0,0,22.93,512a23,23,0,0,0,7.67-1.31L149.83,469c121.85,62.92,271.64,15.14,334.56-106.71A248.32,248.32,0,0,0,439.27,72.72ZM418,402.62A218.34,218.34,0,0,1,161.24,441a23.07,23.07,0,0,0-18.45-1.43L34.47,477.52,72.39,369.2A23.11,23.11,0,0,0,71,350.75C14.4,244.3,54.83,112.13,161.28,55.54A218.29,218.29,0,0,1,263.68,30h0C384.22,30,481.94,127.72,482,248.26A218.25,218.25,0,0,1,418,402.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356,270.47a29.33,29.33,0,0,0-41.43,0L302.05,283a181.72,181.72,0,0,1-73-73l12.49-12.49a29.33,29.33,0,0,0,0-41.43l-33.67-33.67a29.33,29.33,0,0,0-41.43,0l-26.95,26.87c-15.42,15.43-16.19,41.95-2.16,74.68,12.18,28.42,34.46,59.65,62.76,87.94s59.53,50.58,87.94,62.76c15.55,6.67,29.7,10,41.92,10,13.5,0,24.66-4.06,32.76-12.15l26.93-26.94h0a29.3,29.3,0,0,0,0-41.43Zm-14.5,80.79c-4.4,4.4-17.94,5.95-41.6-4.19-25-10.71-52.89-30.75-78.55-56.4S175.66,237.12,165,212.13c-10.15-23.67-8.6-37.21-4.2-41.61l26.41-26.42,32.63,32.63-15.64,15.64a22.9,22.9,0,0,0-4.24,26.68,211.84,211.84,0,0,0,93,93.05,22.9,22.9,0,0,0,26.68-4.24l15.64-15.64,32.63,32.63Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.3f232ebf8ccf1f0ca56e9985d621176f.svg";
export { ForwardRef as ReactComponent };